import { render, staticRenderFns } from "./v-container.vue?vue&type=template&id=5cdd018b"
import script from "./v-container.vue?vue&type=script&lang=js"
export * from "./v-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cdd018b')) {
      api.createRecord('5cdd018b', component.options)
    } else {
      api.reload('5cdd018b', component.options)
    }
    module.hot.accept("./v-container.vue?vue&type=template&id=5cdd018b", function () {
      api.rerender('5cdd018b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/plugins/components/container/v-container.vue"
export default component.exports